import { render, staticRenderFns } from "./ListDynamicData.vue?vue&type=template&id=0efe062d&scoped=true&"
import script from "./ListDynamicData.vue?vue&type=script&lang=js&"
export * from "./ListDynamicData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efe062d",
  null
  
)

export default component.exports